// extracted by mini-css-extract-plugin
export default {"date":"DatePicker_date__hZZs7","datePart":"DatePicker_datePart__xkad4","label":"DatePicker_label__2-B7v","input":"DatePicker_input__h5ok8"};